import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import AvatarBaseURL from "../../shared/util/avatarBaseURL";
import BookCard from "../../shared/components/common/bookCard";
import { Avatar, NotFoundAnim } from "../../assets";
import "./style.css";
import { GetPublisherBooks } from "../../shared/services/libraryService";
import { Spinner } from "react-bootstrap";
import { GetMyBooks } from "../../shared/services/bookService";
import Animation from "../../shared/components/common/Animation";

function Home() {
  const param = useParams();
  const user = useSelector((state) => state.root.user);
  const [booksList, setBookList] = useState(null);
  const [loader, setLoader] = useState(false);
  const getPublisherBooks = async () => {
    setLoader(true);
    setBookList(null);
    GetPublisherBooks(user?.token)
      .then((res) => {
        if (res.statusText === "OK") {
          setBookList(res.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error.message);
      });
  };
  const getBookReadersBooks = async () => {
    setLoader(true);
    setBookList(null);
    GetMyBooks(user?.token)
      .then((res) => {
        if (res.statusText === "OK") {
          setBookList(res.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error.message);
      });
  };
  useEffect(() => {
    if (user?.user?.type === "publisher") {
      getPublisherBooks();
    } else {
      getBookReadersBooks();
    }
  }, []);
  return (
    <div data-aos="fade-up" data-aos-duration="500">
      <section className="steezdesigns-content">
        <div className="container">
          <div className="steezdesigns-flex">
            <div className="steezdesigns-img-text-col">
              <div className="steezdesigns-profile-img">
                <img
                  load="lazy"
                  src={
                    user?.user?.avatar
                      ? `${AvatarBaseURL}${user?.user?.avatar}`
                      : `${Avatar}`
                  }
                  alt="steez-design-edit"
                />
              </div>
              <div className="steezdesigns-profile-text">
                <h3>
                  {user?.user?.firstname} {user?.user?.lastname}
                </h3>
                <h6>@{user?.user?.username}</h6>
                <p>{user?.user?.bio}</p>
              </div>
            </div>
            <div className="steezdesigns-followers-col">
              <ul>
                <li>
                  <h4>{user?.books}</h4>
                  <h5>Books</h5>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="driptivity-content2 driptivity-content-tour">
        <div className="container">
          <h2 className="mb-3">My Books</h2>
          <div className="row">
            <div className="col-md-12">
              <div className={`recent-activity-flex`}>
                {loader ? (
                  <div className="d-flex align-items-center">
                    <Spinner animation="grow" size="lg" />
                  </div>
                ) : booksList && booksList.length > 0 ? (
                  booksList?.map((item, key) => {
                    return user?.user?.type === "publisher" ? (
                      <BookCard
                        key={key}
                        item={item}
                        isPublisher
                        getPublisherBooks={getPublisherBooks}
                      />
                    ) : (
                      <BookCard
                        key={key}
                        item={item.library}
                        isBookReader
                        status={item.status}
                        bookID={item._id}
                        isBuy={false}
                        isPublisher={false}
                        getBookReadersBooks={getBookReadersBooks}
                      />
                    );
                  })
                ) : (
                  <div className="pb-5 animation-container">
                    <Animation Pic={NotFoundAnim} Message={"No Books Found"} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
